import React from "react";

//styles
import "../css/videolightbox.css";


export class VideoLightbox extends React.Component {
    constructor(props){
        super(props);
        this.closeVideobox = this.closeVideobox.bind( this );
        this.openVideobox = this.openVideobox.bind( this );
    }

    componentDidMount(){
        console.log("Loaded video Box");
        console.log(this.props);
        this.openVideobox();
    }
    componentWillReceiveProps( nextProps ){
        this.openVideobox();
        document.getElementById(this.props.activeVideo.videoID).play();
    }
    closeVideobox(){
        document.getElementById(this.props.activeVideo.videoID).pause();
        this.videobox.classList.remove( "active" );
        document.getElementsByTagName( "BODY" )[0].classList.remove( "noScroll" );
    }
    openVideobox(){
        console.log(this.props);
        // document.getElementById(this.props.videoPlayerID).play();
        this.videobox.classList.add( "active" );
        this.videobox.classList.add( this.getMobileOperatingSystem() );
        document.getElementsByTagName( "BODY" )[0].classList.add( "noScroll" );
    }

    getMobileOperatingSystem() {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return "Windows Phone";
        }

        if (/android/i.test(userAgent)) {
            return "Android";
        }

        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return "iOS";
        }

        return "unknown";
    }


    render() {
        let activeVideo = this.props.activeVideo;
        return (
            <div className="videobox" id="videobox" ref={( div ) => {this.videobox = div;}}>
                <div className="videobox-inner">
                    <video key={activeVideo.videoID} id={activeVideo.videoID} controls={activeVideo.controls} autoPlay={activeVideo.autoPlay}>
                        <source src={activeVideo.videoURL} type="video/mp4"/>
                        Your browser does not support the video tag
                    </video>
                    <button onClick={this.closeVideobox} className="videobox-close">Close</button>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/layouts/videoPlayer.js